import { SelectedReserveType } from "@/atoms/shared"
import { RelendDialog } from "@/components/relendDialog"
import { NFTDetailType } from "@/hooks/useFetchNFT"
import { Box, Grid, RadioGroup, Typography } from "@mui/material"
import React from "react"

import NoDataIcon from "@/assets/icons/no-data.svg"
import Button from "@/components/base/Button"
import useTrans from "@/hooks/useTrans"
import Stack from "@mui/material/Stack"
import Image from "next/image"
import * as styles from "../styles"
import NFTItem from "./NFTItem"
import SearchInput from "./SearchInput"

interface BorrowRepayDialogProps {
  title: string
  isOpen: boolean
  handleCloseModal: () => void
  availableLendingNFT?: NFTDetailType[]
  handleSearchText: (text: string) => void
  handleChooseNFTClick: () => void
  handleSelectNFTChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  shouldRefreshCheckbox: boolean
  selectedReserve: SelectedReserveType
  nftMintSelected?: string
  setNftMintSelected: React.Dispatch<React.SetStateAction<string | undefined>>
}

const BorrowRepayDialog = ({
  isOpen,
  handleCloseModal,
  title,
  availableLendingNFT,
  handleSearchText,
  handleChooseNFTClick,
  handleSelectNFTChange,
  shouldRefreshCheckbox,
  selectedReserve,
  nftMintSelected,
  setNftMintSelected,
}: BorrowRepayDialogProps) => {
  const trans = useTrans()

  return (
    <RelendDialog
      open={isOpen}
      handleClose={handleCloseModal}
      title={title}
      maxWidth='md2'
      data-testid='modal-select-nft'
      buttons={
        availableLendingNFT?.length ? (
          <Button data-testid='button-choose-nft' variant='primary' onClick={handleChooseNFTClick}>
            {trans.dashboard.modal.choose_nft}
          </Button>
        ) : (
          <Button data-testid='button-close-choose-nft' variant='outlined' onClick={handleCloseModal}>
            {trans.dashboard.modal.close}
          </Button>
        )
      }
    >
      <Stack alignItems='center' gap={2}>
        <SearchInput
          handleSearchText={handleSearchText}
          placeholder={trans.dashboard.modal.search_by_name_or_address}
        />

        {availableLendingNFT && availableLendingNFT.length > 0 && (
          <RadioGroup sx={{ width: "100%" }} name='select-nft-group' onChange={handleSelectNFTChange}>
            <Grid container spacing={2}>
              {availableLendingNFT.map((item, index) => (
                <Grid key={`${item.name}-${item.mintAddress}-${index}`} item xs={6} sm={4} md={3}>
                  <NFTItem
                    nftDetail={item}
                    shouldRefreshCheckbox={shouldRefreshCheckbox}
                    selectedReserve={selectedReserve}
                    nftMintSelected={nftMintSelected}
                    setNftMintSelected={setNftMintSelected}
                    isClaimingVoucher={false}
                  />
                </Grid>
              ))}
            </Grid>
          </RadioGroup>
        )}

        {availableLendingNFT && availableLendingNFT.length === 0 && (
          <Box sx={{ margin: "32px" }}>
            <Image src={NoDataIcon} alt='no-data-icon' width={161} height={161} />
            <Typography sx={styles.typoNoData}>{trans.dashboard.modal.no_nft_to_send}</Typography>
          </Box>
        )}
      </Stack>
    </RelendDialog>
  )
}

export default BorrowRepayDialog
